import SubscriptionsEmpty from "@images/illustrations/subscriptions_2.svg"
import { BoxOfferInvitationEntity } from "@modules/boxOffer/entities/boxOfferInvitationEntity"
import { MemberOfferInvitationItem } from "@modules/members/memberOffers/components/memberOfferInvitationItem"
import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"

type Props = {
  boxOfferInvitations?: BoxOfferInvitationEntity[]
  emptyText?: string
} & React.ComponentProps<"div">

export function BoxLeadOffersList({ boxOfferInvitations = [], emptyText, ...props }: Props) {
  const defaultClassName = "flex flex-column gap-4 w-full"
  const defaultClassNameEmpty = "flex justify-content-center align-items-center gap-4 w-full mx-4 my-1"
  const theme = useTheme()

  if (boxOfferInvitations.length === 0) {
    return (
      <div className={props.className ?? defaultClassNameEmpty}>
        <HUText fontStyle="HS" color={theme.neutralColor700} className=" flex w-6">
          {emptyText}
        </HUText>
        <div
          className="flex bg-contain bg-center bg-no-repeat w-6 h-10rem h-4"
          style={{ backgroundImage: `url(${SubscriptionsEmpty})` }}
        ></div>
      </div>
    )
  }

  return (
    <div className={props.className ?? defaultClassName}>
      {boxOfferInvitations.map((item) => {
        if (item instanceof BoxOfferInvitationEntity) {
          return <MemberOfferInvitationItem item={item} key={item.id} />
        }
      })}
    </div>
  )
}
